import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import { createStructuredSelector } from 'reselect';

import { AUTO_LOGOUT_TIMEOUT } from 'constants';

import IntercomWithUser from './IntercomWithUser';
import Router from '../Router';

import * as authActions from '../../reducers/auth/reducer';
import { makeSelectUser } from '../../reducers/user/selectors';

import CountryContextProvider from '../../hooks/useCountryContext';
import { CountryList, Country } from '../../enums/country';

function App({ logout, user }) {
  const countryCode = (user && user.getIn(['locale', 'countryCode'])) || CountryList.GREAT_BRITAIN;
  const currencyCode =
    (user && user.getIn(['locale', 'currencyCode'])) ||
    Country[CountryList.GREAT_BRITAIN].currency.code;
  return (
    <IdleTimer idleAction={logout} timeout={AUTO_LOGOUT_TIMEOUT}>
      <CountryContextProvider countryCode={countryCode} currencyCode={currencyCode}>
        <Router />
      </CountryContextProvider>
      <IntercomWithUser />
    </IdleTimer>
  );
}

App.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(authActions.logout()),
  };
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
